// Copyright (c) 2022 Celadon Development LLC, All rights reserved.
// Author Alexander Mikholap <alexander.miholap@celadon.ae>

import React from 'react';
import PropTypes from 'prop-types';
import MediaQuery from 'react-responsive';

import { withStyles } from '@material-ui/core/styles';
import styles from './styles';

import { DownloadIcon, InputContainer } from '../../components';

import girl from '../../../../images/home-girl.png';


const BarcodeBlock = ({
  classes,
  title_line1,
  title_line2,
  isHomePage
}) => {
  return (
    <div className={classes.mainContainer}>
      <MediaQuery minWidth={1000}>
        <div className={classes.imageContainer}>
          <img className={classes.backgroundImage} src={girl} alt={'girl'} />
        </div>
      </MediaQuery>
      <div className={classes.mainInnerContainer}>
        <div>
          <h1 className={classes.text}>{title_line1}</h1>
          <h1 className={classes.text}>{title_line2}</h1>
        </div>
        <div className={classes.inputContainer}>
          <InputContainer isHomePage={isHomePage} />
        </div>
        <div className={classes.downloadIconContainer}>
          <DownloadIcon isIndex />
        </div>
      </div>
    </div>
  );
};

BarcodeBlock.propTypes = {
  classes: PropTypes.object,
  isHomePage: PropTypes.bool,
  title_line1: PropTypes.string,
  title_line2: PropTypes.string,
};

BarcodeBlock.defaultProps = {
  classes: {},
  isHomePage: false,
  title_line1: '',
  title_line2: '',
};

export default withStyles(styles)(BarcodeBlock);
